<template>
  <div>
    <Card>
      <Row class="search-con" type="flex" align="middle" :gutter="10">
        <Col span="4">
          <Input v-model="searchKeyword" placeholder="请输入端口号或种类进行搜索" clearable>
            <Button slot="append" icon="ios-search" @click="handleSearch"></Button>
          </Input>
        </Col>
        <Col span="3">
          <Select v-model="selectedFactoryId" placeholder="请选择工厂" clearable style="width: 100%;" @on-change="handleSearch">
            <Option v-for="factory in factoryList" :value="factory.id" :key="factory.id">
              {{ factory.name }}
            </Option>
          </Select>
        </Col>
        <Col span="3">
          <Select v-model="selectedType" placeholder="请选择类型" clearable style="width: 100%;" @on-change="handleSearch">
            <Option v-for="type in typeList" :value="type" :key="type">
              {{ type }}
            </Option>
          </Select>
        </Col>
        <Col span="2">
          <Button @click="handleSearch" type="primary">搜索</Button>
        </Col>
        <Col span="4">
          <Button @click="showBatchUpdateVersionModal" type="warning" icon="ios-cloud-upload" style="margin-right: 10px;">
            批量更新软件版本
          </Button>
        </Col>
        <Col span="4">
          <Button @click="showBatchUpdateModal" type="success" icon="ios-cloud-upload">
            批量更新模型
          </Button>
        </Col>
      </Row>
      <tables editable :columns="columns" v-model="tableData" :loading="tableLoading" />
      <Row class="page-con">
        <div class="page-bottom">
          <Page :current="page" :total="total" :page-size="pageSize" :page-size-opts="[10, 20, 30, 50, 100]" show-sizer show-elevator @on-change="changePage"
            @on-page-size-change="changePageSize" />
        </div>
      </Row>
    </Card>

    <!-- 批量更新模型Modal -->
    <Modal
      v-model="batchUpdateModal"
      title="批量更新模型"
      :width="1000"
      :mask-closable="false"
      footer-hide
    >
      <Form :model="batchUpdateForm" :label-width="120">
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="选择模型">
              <Select v-model="batchUpdateForm.modelId" placeholder="请选择要更新的模型" @on-change="onModelChange">
                <Option v-for="model in modelList" :value="model.id" :key="model.id">
                  {{ model.modelName }} ({{ model.showName }})
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="选择工厂">
              <Select v-model="batchUpdateForm.selectedFactories" placeholder="请选择工厂（可多选）" multiple @on-change="onModelFactoryChange">
                <Option v-for="factory in factoryList" :value="factory.name" :key="factory.id">
                  {{ factory.name }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>

        <Row v-if="batchUpdateForm.selectedFactories && batchUpdateForm.selectedFactories.length > 0">
          <Col span="24">
            <FormItem label="选择设备">
              <div v-for="factory in batchUpdateForm.selectedFactories" :key="factory" class="factory-device-section">
                <div class="factory-header">
                  <h4>{{ factory }}</h4>
                  <div class="factory-controls">
                    <Checkbox
                      v-model="modelFactorySelectAll[factory]"
                      @on-change="toggleModelFactoryAllDevices(factory, $event)"
                    >
                      全选该工厂设备
                    </Checkbox>
                    <span class="device-count">
                      已选择 {{ getSelectedModelDevicesCount(factory) }} 台设备
                    </span>
                  </div>
                </div>
                <div class="device-list">
                  <Checkbox
                    v-for="device in getFactoryDevices(factory)"
                    :key="device.id"
                    :value="device.mac_address"
                    :checked="isModelDeviceSelected(factory, device.mac_address)"
                    @on-change="toggleModelDeviceSelection(factory, device.mac_address, $event)"
                    style="display: block; margin: 5px 0;"
                  >
                    <Tag :color="getDeviceTagColor(device.type)" style="margin-right: 5px;">
                      {{ device.mac_address }}
                    </Tag>
                    <span>{{ device.type }}</span>
                  </Checkbox>
                </div>
              </div>
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="24">
            <FormItem>
              <Button
                type="primary"
                @click="batchUpdateModel"
                :loading="updateLoading"
                :disabled="!batchUpdateForm.modelId || !batchUpdateForm.selectedFactories || batchUpdateForm.selectedFactories.length === 0"
              >
                <Icon type="ios-cloud-upload"></Icon>
                批量更新模型
              </Button>
              <Button
                type="success"
                @click="batchUpdateAllModel"
                :loading="updateLoading"
                :disabled="!batchUpdateForm.modelId"
                style="margin-left: 10px;"
              >
                <Icon type="ios-send"></Icon>
                全量发布
              </Button>
              <Button @click="resetBatchForm" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>

    <!-- 批量更新软件版本Modal -->
    <Modal
      v-model="batchUpdateVersionModal"
      title="批量更新软件版本"
      :width="1000"
      :mask-closable="false"
      footer-hide
    >
      <Form :model="batchUpdateVersionForm" :label-width="120">
        <Row :gutter="16">
          <Col span="8">
            <FormItem label="选择类型">
              <Select v-model="batchUpdateVersionForm.versionType" placeholder="请选择类型" clearable style="width: 100%;" @on-change="onVersionTypeChange">
                <Option v-for="type in typeList" :value="type" :key="type">
                  {{ type }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="选择版本">
              <Select v-model="batchUpdateVersionForm.versionId" placeholder="请选择要更新的版本" @on-change="onVersionChange">
                <Option v-for="version in versionList" :value="version.id" :key="version.id">
                  {{ version.versionName }} ({{ version.versionCode }})
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="选择工厂">
              <div style="display: flex; gap: 8px; align-items: center;">
                <Select v-model="batchUpdateVersionForm.selectedFactories" placeholder="请选择工厂（可多选）" multiple @on-change="onVersionFactoryChange" style="flex: 1;">
                  <Option v-for="factory in filteredFactoryListForVersion" :value="factory.name" :key="factory.id">
                    {{ factory.name }}
                  </Option>
                </Select>
                <Button
                  type="primary"
                  size="small"
                  @click="selectAllVersionFactories"
                  :disabled="!filteredFactoryListForVersion || filteredFactoryListForVersion.length === 0"
                >
                  全选
                </Button>
              </div>
            </FormItem>
          </Col>
        </Row>

        <Row v-if="batchUpdateVersionForm.selectedFactories && batchUpdateVersionForm.selectedFactories.length > 0">
          <Col span="24">
            <FormItem label="选择设备">
              <div style="margin-bottom: 10px;">
                <Button
                  type="success"
                  size="small"
                  @click="selectAllVersionDevices"
                  icon="ios-checkmark-circle"
                >
                  全选所有设备
                </Button>
                <Button
                  type="default"
                  size="small"
                  @click="clearAllVersionDevices"
                  icon="ios-close-circle"
                  style="margin-left: 8px;"
                >
                  清空所有设备
                </Button>
                <span style="margin-left: 15px; color: #999;">
                  已选择 {{ getTotalSelectedVersionDevicesCount() }} 台设备
                </span>
              </div>
              <div v-for="factory in batchUpdateVersionForm.selectedFactories" :key="factory" class="factory-device-section">
                <div class="factory-header">
                  <h4>{{ factory }}</h4>
                  <div class="factory-controls">
                    <Checkbox
                      v-model="factorySelectAll[factory]"
                      @on-change="toggleFactoryAllDevices(factory, $event)"
                    >
                      全选该工厂设备
                    </Checkbox>
                    <span class="device-count">
                      已选择 {{ getSelectedDevicesCount(factory) }} 台设备
                    </span>
                  </div>
                </div>
                <div class="device-list">
                  <Checkbox
                    v-for="device in getFactoryDevices(factory)"
                    :key="device.id"
                    :value="device.mac_address"
                    :checked="isDeviceSelected(factory, device.mac_address)"
                    @on-change="toggleDeviceSelection(factory, device.mac_address, $event)"
                    style="display: block; margin: 5px 0;"
                  >
                    <Tag :color="getDeviceTagColor(device.type)" style="margin-right: 5px;">
                      {{ device.mac_address }}
                    </Tag>
                    <span>{{ device.type }}</span>
                  </Checkbox>
                </div>
              </div>
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="24">
            <FormItem>
              <Button
                type="primary"
                @click="batchUpdateVersion"
                :loading="versionUpdateLoading"
                :disabled="!batchUpdateVersionForm.versionId || !batchUpdateVersionForm.selectedFactories || batchUpdateVersionForm.selectedFactories.length === 0"
              >
                <Icon type="ios-cloud-upload"></Icon>
                批量更新软件版本
              </Button>
              <Button
                type="warning"
                @click="batchUpdateAllVersion"
                :loading="versionUpdateLoading"
                :disabled="!batchUpdateVersionForm.versionId"
                style="margin-left: 10px;"
              >
                <Icon type="ios-send"></Icon>
                全量发布
              </Button>
              <Button @click="resetVersionForm" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>

    <!-- 绑定工厂Modal -->
    <Modal
      v-model="bindFactoryModal"
      title="绑定工厂"
      :mask-closable="false"
      @on-ok="confirmBindFactory"
      @on-cancel="cancelBindFactory"
    >
      <Form :model="bindFactoryForm" :label-width="100">
        <FormItem label="选择工厂">
          <Select v-model="bindFactoryForm.factoryId" placeholder="请选择工厂" style="width: 100%;">
            <Option v-for="factory in factoryList" :value="factory.id" :key="factory.id">
              {{ factory.name }}
            </Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Tables from '_c/tables/table-only.vue'
import Forms from './add_music_library_form.vue'
import { device_list, edit_device, getModelList, version_addBatch, version_batchUpdate, version_batchUpdateAll, model_batchUpdate, model_batchUpdateAll, baseVersionList, getAllFactory, updateDeviceFactory, getVersionTypes } from '@/api/data'
import axios from '@/libs/api.request'
import { getTimeDifference } from '@/api/uploadOss'

export default {
  name: 'finance',
  components: {
    Tables,
    Forms
  },
  data () {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      searchKeyword: '',
      selectedFactoryId: null, // 选中的工厂ID
      selectedType: null, // 选中的类型
      typeList: [], // 类型列表
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      startTime: '',
      endTime: '',
      // 批量更新相关
      batchUpdateModal: false,
      modelList: [],
      factoryList: [], // 工厂列表，包含完整的工厂信息
      factoryMap: {}, // 工厂名称到工厂ID的映射
      allDevices: [],
      updateLoading: false,
      batchUpdateForm: {
        modelId: '',
        selectedFactories: []
      },
      selectedModel: null,
      selectedModelDevices: {}, // 按工厂分组的设备选择 {factoryName: [port1, port2, ...]}
      modelFactorySelectAll: {}, // 每个工厂的全选状态 {factoryName: true/false}
      // 批量更新软件版本相关
      batchUpdateVersionModal: false,
      versionList: [],
      versionUpdateLoading: false,
      batchUpdateVersionForm: {
        versionType: null,
        versionId: '',
        selectedFactories: []
      },
      selectedVersion: null,
      selectedVersionDevices: {}, // 按工厂分组的设备选择 {factoryName: [port1, port2, ...]}
      factorySelectAll: {}, // 每个工厂的全选状态 {factoryName: true/false}
      // 绑定工厂相关
      bindFactoryModal: false,
      bindFactoryForm: {
        factoryId: null
      },
      currentDeviceId: null, // 当前要绑定工厂的设备ID
      columns: [
        { type: 'index', title: '序号', width: 100, align: 'center' },
        { title: '机器端口', key: 'mac_address', editable: true, align: 'center', sortable: true },
        { title: '种类', key: 'type', editable: true, align: 'center' },
        { title: '所属工厂', key: 'factorName', editable: true, align: 'center' },
        {
          title: '当前使用模型',
          key: 'location',
          align: 'center',
          width: 200,
          render: (h, params) => {
            const model = params.row.location
            return h('div', [
              h('Tag', {
                props: {
                  color: model ? 'blue' : 'default',
                  size: 'small'
                },
                style: {
                  maxWidth: '180px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                  cursor: 'help'
                },
                attrs: {
                  title: model || '未设置'
                }
              }, model || '未设置')
            ])
          }
        },
        {
          title: '当前版本号',
          key: 'version_name',
          align: 'center',
          width: 150,
          render: (h, params) => {
            const versionName = params.row.version_name
            return h('div', [
              h('Tag', {
                props: {
                  color: versionName ? 'green' : 'default',
                  size: 'small'
                },
                style: {
                  maxWidth: '130px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                  cursor: 'help'
                },
                attrs: {
                  title: versionName || '未设置'
                }
              }, versionName || '未设置')
            ])
          }
        },
        { title: '创建时间', key: 'create_time', editable: true, sortable: true },
        {
          title: '更新时间',
          key: 'update_time',
          editable: true,
          sortable: true,
          sortType: 'desc',
          render: (h, params) => {
            let texts = this.formatTimeDifference(params.row.update_time)
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return h('Dropdown', {
              props: {
                trigger: 'click',
                placement: 'bottom-end',
                transfer: true
              },
              on: {
                'on-click': (name) => {
                  switch (name) {
                    case 'logs':
                      this.viewRunningLogs(params.row.id)
                      break
                    case 'inspection':
                      this.viewInspectionInfo(params.row)
                      break
                    case 'setting':
                      this.deviceSetting(params.row)
                      break
                    case 'factory':
                      this.showBindFactoryModal(params.row)
                      break
                  }
                }
              }
            }, [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                }
              }, [
                '操作',
                h('Icon', {
                  props: {
                    type: 'ios-arrow-down'
                  }
                })
              ]),
              h('DropdownMenu', {
                slot: 'list'
              }, [
                h('DropdownItem', {
                  props: {
                    name: 'logs'
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'ios-paper'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }),
                  '查看运行日志'
                ]),
                h('DropdownItem', {
                  props: {
                    name: 'inspection'
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'ios-information-circle'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }),
                  '查看验布信息'
                ]),
                h('DropdownItem', {
                  props: {
                    name: 'setting'
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'ios-settings'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }),
                  '设置'
                ]),
                h('DropdownItem', {
                  props: {
                    name: 'factory',
                    divided: true
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'ios-link'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }),
                  '绑定工厂'
                ])
              ])
            ])
          }
        }
      ],
      tableData: []
    }
  },
  computed: {
    filteredDevices () {
      if (!this.batchUpdateForm.factoryNames || this.batchUpdateForm.factoryNames.length === 0) {
        return []
      }
      return this.allDevices.filter(device => this.batchUpdateForm.factoryNames.includes(device.factorName))
    },
    // 过滤出有设备的工厂列表（用于批量更新软件版本）
    filteredFactoryListForVersion () {
      if (!this.allDevices || this.allDevices.length === 0) {
        return []
      }
      // 获取所有有设备的工厂名称
      const factoryNamesWithDevices = new Set()
      this.allDevices.forEach(device => {
        if (device.factorName) {
          factoryNamesWithDevices.add(device.factorName)
        }
      })
      // 过滤工厂列表，只返回有设备的工厂
      return this.factoryList.filter(factory => factoryNamesWithDevices.has(factory.name))
    }
    // 移除filteredVersionDevices，改用方法获取
  },
  methods: {
    // 本地时间格式化方法，优化显示
    formatTimeDifference (originalTime) {
      if (originalTime == null || originalTime == '') { return '' }

      const time = new Date(originalTime.replace(/-/g, '/'))
      const now = new Date()
      const differenceInMs = now - time
      const differenceInMinutes = Math.floor(differenceInMs / (1000 * 60))
      const differenceInHours = Math.floor(differenceInMinutes / 60)
      const differenceInDays = Math.floor(differenceInHours / 24)

      if (differenceInDays > 3) {
        return `${time.toLocaleString()}`
      } else if (differenceInDays >= 1) {
        return `${differenceInDays}天前`
      } else if (differenceInHours >= 1) {
        const remainingMinutes = differenceInMinutes % 60
        return remainingMinutes > 0 ? `${differenceInHours}小时${remainingMinutes}分钟前` : `${differenceInHours}小时前`
      } else if (differenceInMinutes >= 1) {
        return `${differenceInMinutes}分钟前`
      } else {
        return '刚刚'
      }
    },
    handleReset () {
      this.searchKeyword = ''
      this.selectedFactoryId = null
      this.selectedType = null
      this.page = 1
      this.handleSearch()
    },
    changeStatus (value, params) {
      let data = new FormData()
      data.append('open', value)
      edit_device(params.row.id, data).then((res) => {
        if (res.data.code == 200) {
          this.handleSearch()
          this.$Message.success('成功!')
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    download (url) {
      window.open(url, '_blank')
    },
    showAddModal () {
      this.addModal = true
      this.resetFlag = !this.resetFlag
      music_library_classify().then((res) => {
        var classifyIds = res.data.data.records
        this.$refs.add.setClassifyData(classifyIds)
      })
    },
    showEditModal (params) {
      this.editData = params.row
      this.editModal = true
      music_library_classify().then((res) => {
        var classifyIds = res.data.data.records
        this.$refs.edit.setClassifyData(classifyIds)
      })
      this.$refs.edit.setEditData(this.editData)
    },
    cancel () { },
    changePage (page) {
      this.page = page
      this.handleSearch()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleSearch () {
      this.setTableLoading(true)
      let params = {
        page: this.page,
        pageSize: this.pageSize
      }

      if (this.searchKeyword) {
        params.keyword = this.searchKeyword
      }

      if (this.selectedFactoryId) {
        params.factor_id = this.selectedFactoryId
      }

      if (this.selectedType) {
        params.type = this.selectedType
      }

      device_list(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.setTableLoading(false)
      })
    },
    setTableLoading (state) {
      this.tableLoading = state
    },
    viewRunningLogs (deviceId) {
      this.$router.push({
        path: '/running_logs',
        query: {
          port: deviceId
        }
      })
    },
    deviceSetting (deviceData) {
      this.$router.push({
        path: '/device_setting',
        query: {
          deviceId: deviceData.id,
          macAddress: deviceData.mac_address,
          type: deviceData.type,
          factoryName: deviceData.factorName
        }
      })
    },
    viewInspectionInfo (deviceData) {
      this.$router.push({
        path: '/inspection_info',
        query: {
          deviceId: deviceData.id,
          macAddress: deviceData.mac_address,
          type: deviceData.type,
          factoryName: deviceData.factorName
        }
      })
    },
    async showBatchUpdateModal () {
      this.batchUpdateModal = true
      await this.loadModelList()
      await this.loadAllDevices()
      this.loadFactoryList()
    },
    async loadModelList () {
      try {
        const res = await getModelList(1, 1000, '')
        if (res.data.code === 200) {
          this.modelList = res.data.data.records || []
        }
      } catch (error) {
        this.$Message.error('加载模型列表失败')
        console.error(error)
      }
    },
    async loadAllDevices (type = null) {
      try {
        const params = {
          page: 1,
          pageSize: 10000 // 获取所有设备
        }
        // 如果传入了类型参数，则添加到请求参数中
        if (type) {
          params.type = type
        }
        const res = await device_list(params)
        if (res.data.code === 200) {
          this.allDevices = res.data.data.records || []
        }
      } catch (error) {
        this.$Message.error('加载设备列表失败')
        console.error(error)
      }
    },
    async loadFactoryList () {
      try {
        const res = await getAllFactory()

        if (res.data.code === 200) {
          // 从data.records中获取工厂列表
          this.factoryList = res.data.data.records || []

          // 创建工厂名称到ID的映射
          this.factoryMap = {}
          this.factoryList.forEach(factory => {
            this.factoryMap[factory.name] = factory.id
          })
        } else {
          console.error('获取工厂列表失败:', res.data.msg)
          this.$Message.error('获取工厂列表失败: ' + (res.data.msg || '未知错误'))
        }
      } catch (error) {
        this.$Message.error('加载工厂列表失败')
        console.error(error)
      }
    },
    onModelChange (modelId) {
      this.selectedModel = this.modelList.find(model => model.id === modelId)
    },
    onModelFactoryChange () {
      // 工厂改变时，清空设备选择并重置全选状态
      this.selectedModelDevices = {}
      this.modelFactorySelectAll = {}

      // 为每个选中的工厂初始化设备选择数组
      this.batchUpdateForm.selectedFactories.forEach(factory => {
        this.$set(this.selectedModelDevices, factory, [])
        this.$set(this.modelFactorySelectAll, factory, false)
      })
    },
    getSelectedModelDevicesCount (factoryName) {
      return this.selectedModelDevices[factoryName] ? this.selectedModelDevices[factoryName].length : 0
    },
    toggleModelFactoryAllDevices (factoryName, checked) {
      if (checked) {
        // 全选：选择该工厂下所有设备的端口号
        const factoryDevices = this.getFactoryDevices(factoryName)
        this.$set(this.selectedModelDevices, factoryName, factoryDevices.map(device => device.mac_address))
      } else {
        // 取消全选：清空选择
        this.$set(this.selectedModelDevices, factoryName, [])
      }
    },
    isModelDeviceSelected (factoryName, devicePort) {
      const selectedDevices = this.selectedModelDevices[factoryName] || []
      return selectedDevices.includes(devicePort)
    },
    toggleModelDeviceSelection (factoryName, devicePort, checked) {
      const selectedDevices = this.selectedModelDevices[factoryName] || []

      if (checked) {
        // 添加设备到选择列表
        if (!selectedDevices.includes(devicePort)) {
          selectedDevices.push(devicePort)
        }
      } else {
        // 从选择列表中移除设备
        const index = selectedDevices.indexOf(devicePort)
        if (index > -1) {
          selectedDevices.splice(index, 1)
        }
      }

      // 更新选择列表
      this.$set(this.selectedModelDevices, factoryName, [...selectedDevices])

      // 更新全选状态
      const factoryDevices = this.getFactoryDevices(factoryName)
      const isAllSelected = factoryDevices.length > 0 && selectedDevices.length === factoryDevices.length
      this.$set(this.modelFactorySelectAll, factoryName, isAllSelected)
    },
    getDeviceTagColor (type) {
      // 根据设备类型返回不同颜色
      const colors = ['blue', 'green', 'orange', 'red', 'purple']
      const index = type.length % colors.length
      return colors[index]
    },
    convertDeviceType (type) {
      // 将设备类型转换，如 "kty-验布机" → "kty_model"
      if (type.includes('kty')) {
        return 'kty_model'
      }
      // 可以根据需要添加更多转换规则
      // 先替换非字母数字字符为下划线，然后去除连续的下划线，最后加上_model
      return type.replace(/[^a-zA-Z0-9]/g, '_')
        .replace(/_+/g, '_') // 将多个连续下划线替换为单个下划线
        .replace(/^_|_$/g, '') // 去除开头和结尾的下划线
        .toLowerCase() + '_model'
    },
    async batchUpdateModel () {
      if (!this.selectedModel) {
        this.$Message.error('请选择要更新的模型')
        return
      }

      if (!this.batchUpdateForm.selectedFactories || this.batchUpdateForm.selectedFactories.length === 0) {
        this.$Message.error('请选择工厂')
        return
      }

      // 计算总设备数
      let totalDevices = 0
      this.batchUpdateForm.selectedFactories.forEach(factory => {
        const selectedCount = this.getSelectedModelDevicesCount(factory)
        const factoryTotalCount = this.getFactoryDevices(factory).length
        totalDevices += selectedCount > 0 ? selectedCount : factoryTotalCount
      })

      this.$Modal.confirm({
        title: '确认批量更新模型',
        content: `确定要对 ${totalDevices} 台设备进行模型更新吗？${totalDevices === 0 ? '（将更新该工厂所有设备）' : ''}`,
        onOk: async () => {
          this.updateLoading = true
          try {
            // 构建factory_array参数
            const factoryArray = []

            this.batchUpdateForm.selectedFactories.forEach(factoryName => {
              // 获取该工厂的设备端口列表
              const selectedPorts = this.selectedModelDevices[factoryName] || []

              // 如果没有选择具体设备，则port数组为空（表示更新该工厂所有设备）
              const ports = selectedPorts.length > 0 ? selectedPorts : []

              // 获取工厂ID
              const factoryId = this.getFactoryId(factoryName)

              factoryArray.push({
                factory_id: factoryId,
                port: ports
              })
            })

            // 构建请求参数
            const requestData = {
              flaw_model_id: this.selectedModel.id,
              factory_array: factoryArray
            }

            // 调用新的批量更新接口
            let response
            try {
              response = await model_batchUpdate(requestData)
            } catch (apiError) {
              console.log('API方法调用失败，使用备用方式:', apiError)
              // 备用调用方式
              response = await axios.request({
                url: 'aiqc-model-version/batch-update',
                data: requestData,
                method: 'post'
              })
            }

            if (response.data.code === 200) {
              this.$Message.success('批量更新模型成功！')
              this.batchUpdateModal = false
              this.resetBatchForm()
            } else {
              this.$Message.error(response.data.msg || '批量更新失败')
            }
          } catch (error) {
            this.$Message.error('批量更新失败：' + (error.message || '网络错误'))
            console.error(error)
          } finally {
            this.updateLoading = false
          }
        }
      })
    },
    async batchUpdateAllModel () {
      if (!this.selectedModel) {
        this.$Message.error('请选择要发布的模型')
        return
      }

      this.$Modal.confirm({
        title: '确认全量发布模型',
        content: '确定要将该模型全量发布到所有设备吗？',
        onOk: async () => {
          this.updateLoading = true
          try {
            const requestData = {
              flaw_model_id: this.selectedModel.id
            }

            let response
            try {
              response = await model_batchUpdateAll(requestData)
            } catch (apiError) {
              console.log('API方法调用失败，使用备用方式:', apiError)
              response = await axios.request({
                url: 'aiqc-model-version/batch-update-all',
                data: requestData,
                method: 'post'
              })
            }

            if (response.data.code === 200) {
              this.$Message.success('全量发布模型成功！')
              this.batchUpdateModal = false
              this.resetBatchForm()
            } else {
              this.$Message.error(response.data.msg || '全量发布失败')
            }
          } catch (error) {
            this.$Message.error('全量发布失败：' + (error.message || '网络错误'))
            console.error(error)
          } finally {
            this.updateLoading = false
          }
        }
      })
    },
    resetBatchForm () {
      this.batchUpdateForm.modelId = ''
      this.batchUpdateForm.selectedFactories = []
      this.selectedModel = null
      this.selectedModelDevices = {}
      this.modelFactorySelectAll = {}
    },
    isRecentlyUpdated (updateTime) {
      // 判断更新时间是否是最近（比如5分钟内）
      if (!updateTime) return false

      try {
        const updateDate = new Date(updateTime)
        const now = new Date()
        const diffMinutes = (now - updateDate) / (1000 * 60) // 转换为分钟

        // 如果更新时间在5分钟内，认为是刚刚更新
        return diffMinutes <= 5
      } catch (error) {
        console.error('解析更新时间失败:', error)
        return false
      }
    },
    // 批量更新软件版本相关方法
    async showBatchUpdateVersionModal () {
      this.batchUpdateVersionModal = true
      // 确保类型列表已加载
      if (this.typeList.length === 0) {
        await this.loadTypeList()
      }
      // 清空设备列表和版本列表，等待用户选择类型后再加载
      this.allDevices = []
      this.versionList = []
      this.loadFactoryList()
    },
    async loadVersionList () {
      try {
        const params = {}
        // 如果选择了类型，则传递 versionType 参数
        if (this.batchUpdateVersionForm.versionType) {
          params.versionType = this.batchUpdateVersionForm.versionType
        }
        const res = await baseVersionList(params)
        if (res.data.code === 200) {
          this.versionList = res.data.data.records || []
        }
      } catch (error) {
        this.$Message.error('加载版本列表失败')
        console.error(error)
      }
    },
    async onVersionTypeChange () {
      // 类型改变时，清空已选择的版本
      this.batchUpdateVersionForm.versionId = ''
      this.selectedVersion = null
      // 只有选择了类型后，才调用device_list接口并传递type字段
      if (this.batchUpdateVersionForm.versionType) {
        await this.loadAllDevices(this.batchUpdateVersionForm.versionType)
        await this.loadVersionList()
      } else {
        // 如果清空类型选择，清空设备列表和版本列表
        this.allDevices = []
        this.versionList = []
      }
    },
    onVersionChange (versionId) {
      this.selectedVersion = this.versionList.find(version => version.id === versionId)
    },
    onVersionFactoryChange () {
      // 工厂改变时，清空设备选择并重置全选状态
      this.selectedVersionDevices = {}
      this.factorySelectAll = {}

      // 为每个选中的工厂初始化设备选择数组
      this.batchUpdateVersionForm.selectedFactories.forEach(factory => {
        this.$set(this.selectedVersionDevices, factory, [])
        this.$set(this.factorySelectAll, factory, false)
      })
    },
    selectAllVersionFactories () {
      // 全选所有可用工厂
      if (this.filteredFactoryListForVersion && this.filteredFactoryListForVersion.length > 0) {
        this.batchUpdateVersionForm.selectedFactories = this.filteredFactoryListForVersion.map(factory => factory.name)
        // 触发工厂改变事件，初始化设备选择
        this.onVersionFactoryChange()
      }
    },
    selectAllVersionDevices () {
      // 全选所有工厂的所有设备
      this.batchUpdateVersionForm.selectedFactories.forEach(factory => {
        const factoryDevices = this.getFactoryDevices(factory)
        this.$set(this.selectedVersionDevices, factory, factoryDevices.map(device => device.mac_address))
        this.$set(this.factorySelectAll, factory, true)
      })
    },
    clearAllVersionDevices () {
      // 清空所有工厂的设备选择
      this.batchUpdateVersionForm.selectedFactories.forEach(factory => {
        this.$set(this.selectedVersionDevices, factory, [])
        this.$set(this.factorySelectAll, factory, false)
      })
    },
    getTotalSelectedVersionDevicesCount () {
      // 计算所有工厂已选择的设备总数
      let total = 0
      this.batchUpdateVersionForm.selectedFactories.forEach(factory => {
        total += this.getSelectedDevicesCount(factory)
      })
      return total
    },
    getFactoryDevices (factoryName) {
      return this.allDevices.filter(device => device.factorName === factoryName)
    },
    getSelectedDevicesCount (factoryName) {
      return this.selectedVersionDevices[factoryName] ? this.selectedVersionDevices[factoryName].length : 0
    },
    toggleFactoryAllDevices (factoryName, checked) {
      if (checked) {
        // 全选：选择该工厂下所有设备的端口号
        const factoryDevices = this.getFactoryDevices(factoryName)
        this.$set(this.selectedVersionDevices, factoryName, factoryDevices.map(device => device.mac_address))
      } else {
        // 取消全选：清空选择
        this.$set(this.selectedVersionDevices, factoryName, [])
      }
    },
    isDeviceSelected (factoryName, devicePort) {
      const selectedDevices = this.selectedVersionDevices[factoryName] || []
      return selectedDevices.includes(devicePort)
    },
    toggleDeviceSelection (factoryName, devicePort, checked) {
      const selectedDevices = this.selectedVersionDevices[factoryName] || []

      if (checked) {
        // 添加设备到选择列表
        if (!selectedDevices.includes(devicePort)) {
          selectedDevices.push(devicePort)
        }
      } else {
        // 从选择列表中移除设备
        const index = selectedDevices.indexOf(devicePort)
        if (index > -1) {
          selectedDevices.splice(index, 1)
        }
      }

      // 更新选择列表
      this.$set(this.selectedVersionDevices, factoryName, [...selectedDevices])

      // 更新全选状态
      const factoryDevices = this.getFactoryDevices(factoryName)
      const isAllSelected = factoryDevices.length > 0 && selectedDevices.length === factoryDevices.length
      this.$set(this.factorySelectAll, factoryName, isAllSelected)
    },
    async batchUpdateVersion () {
      if (!this.selectedVersion) {
        this.$Message.error('请选择要更新的版本')
        return
      }

      if (!this.batchUpdateVersionForm.selectedFactories || this.batchUpdateVersionForm.selectedFactories.length === 0) {
        this.$Message.error('请选择工厂')
        return
      }

      // 计算总设备数
      let totalDevices = 0
      this.batchUpdateVersionForm.selectedFactories.forEach(factory => {
        const selectedCount = this.getSelectedDevicesCount(factory)
        const factoryTotalCount = this.getFactoryDevices(factory).length
        totalDevices += selectedCount > 0 ? selectedCount : factoryTotalCount
      })

      this.$Modal.confirm({
        title: '确认批量更新软件版本',
        content: `确定要对 ${totalDevices} 台设备进行软件版本更新吗？`,
        onOk: async () => {
          this.versionUpdateLoading = true
          try {
            // 构建factory_array参数
            const factoryArray = []

            this.batchUpdateVersionForm.selectedFactories.forEach(factoryName => {
              // 获取该工厂的设备端口列表
              const selectedPorts = this.selectedVersionDevices[factoryName] || []

              // 如果没有选择具体设备，则port数组为空（表示更新该工厂所有设备）
              const ports = selectedPorts.length > 0 ? selectedPorts : []

              // 这里需要根据工厂名称获取工厂ID，假设工厂名称就是ID或者需要映射
              // 如果工厂名称就是ID，直接使用；否则需要从factoryList中查找对应的ID
              const factoryId = this.getFactoryId(factoryName)

              factoryArray.push({
                factory_id: factoryId,
                port: ports
              })
            })

            // 构建请求参数
            const requestData = {
              base_version_id: this.selectedVersion.id,
              factory_array: factoryArray
            }

            // 调用新的批量更新接口
            let response
            try {
              response = await version_batchUpdate(requestData)
            } catch (apiError) {
              // 备用调用方式
              response = await axios.request({
                url: 'aiqc-version/batch-update',
                data: requestData,
                method: 'post'
              })
            }

            if (response.data.code === 200) {
              this.$Message.success('批量更新软件版本成功！')
              this.batchUpdateVersionModal = false
              this.resetVersionForm()
            } else {
              this.$Message.error(response.data.msg || '批量更新失败')
            }
          } catch (error) {
            this.$Message.error('批量更新失败：' + (error.message || '网络错误'))
            console.error(error)
          } finally {
            this.versionUpdateLoading = false
          }
        }
      })
    },
    async batchUpdateAllVersion () {
      if (!this.selectedVersion) {
        this.$Message.error('请选择要发布的版本')
        return
      }

      this.$Modal.confirm({
        title: '确认全量发布软件版本',
        content: '确定要将该软件版本全量发布到所有设备吗？',
        onOk: async () => {
          this.versionUpdateLoading = true
          try {
            const requestData = {
              base_version_id: this.selectedVersion.id
            }

            let response
            try {
              response = await version_batchUpdateAll(requestData)
            } catch (apiError) {
              response = await axios.request({
                url: 'aiqc-version/batch-update-all',
                data: requestData,
                method: 'post'
              })
            }

            if (response.data.code === 200) {
              this.$Message.success('全量发布软件版本成功！')
              this.batchUpdateVersionModal = false
              this.resetVersionForm()
            } else {
              this.$Message.error(response.data.msg || '全量发布失败')
            }
          } catch (error) {
            this.$Message.error('全量发布失败：' + (error.message || '网络错误'))
            console.error(error)
          } finally {
            this.versionUpdateLoading = false
          }
        }
      })
    },
    getFactoryId (factoryName) {
      // 从工厂映射中获取工厂ID
      const factoryId = this.factoryMap[factoryName]

      if (factoryId) {
        return factoryId
      }

      return factoryName
    },
    resetVersionForm () {
      this.batchUpdateVersionForm.versionType = null
      this.batchUpdateVersionForm.versionId = ''
      this.batchUpdateVersionForm.selectedFactories = []
      this.selectedVersion = null
      this.selectedVersionDevices = {}
      this.factorySelectAll = {}
      this.versionList = []
    },
    // 绑定工厂相关方法
    async showBindFactoryModal (device) {
      this.currentDeviceId = device.id
      this.bindFactoryForm.factoryId = null

      // 确保工厂列表已加载
      if (this.factoryList.length === 0) {
        await this.loadFactoryList()
      }

      // 如果设备已有工厂，设置默认选中
      // 优先通过工厂ID匹配，如果没有ID则通过工厂名称匹配
      if (device.factor_id) {
        // 如果设备有工厂ID，直接使用
        this.bindFactoryForm.factoryId = device.factor_id
      } else if (device.factorName && this.factoryList.length > 0) {
        // 通过工厂名称匹配工厂ID
        const currentFactory = this.factoryList.find(f => f.name === device.factorName)
        if (currentFactory) {
          this.bindFactoryForm.factoryId = currentFactory.id
        }
      }

      this.bindFactoryModal = true
    },
    async confirmBindFactory () {
      if (!this.bindFactoryForm.factoryId) {
        this.$Message.warning('请选择要绑定的工厂')
        return
      }

      if (!this.currentDeviceId) {
        this.$Message.error('设备ID不存在')
        return
      }

      try {
        const res = await updateDeviceFactory(this.currentDeviceId, this.bindFactoryForm.factoryId)
        if (res.data.code === 200) {
          this.$Message.success('绑定工厂成功！')
          this.bindFactoryModal = false
          this.handleSearch() // 刷新列表
        } else {
          this.$Message.error(res.data.msg || '绑定工厂失败')
        }
      } catch (error) {
        this.$Message.error('绑定工厂失败：' + (error.message || '网络错误'))
        console.error(error)
      }
    },
    cancelBindFactory () {
      this.bindFactoryModal = false
      this.bindFactoryForm.factoryId = null
      this.currentDeviceId = null
    },
    async loadTypeList () {
      try {
        const res = await getVersionTypes()
        if (res.data.code === 200) {
          this.typeList = res.data.data || []
        } else {
          this.$Message.error('获取类型列表失败: ' + (res.data.msg || '未知错误'))
          this.typeList = []
        }
      } catch (error) {
        this.$Message.error('加载类型列表失败')
        console.error(error)
        this.typeList = []
      }
    }
  },
  mounted () {
    this.loadFactoryList()
    this.loadTypeList()
    this.handleSearch()
  }
}
</script>

<style scoped>
.search-con {
  margin-bottom: 20px;
}

.device-list {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  padding: 10px;
  background-color: #fafafa;
}

.device-list .ivu-tag {
  margin: 2px;
  cursor: default;
}

.factory-device-section {
  margin-bottom: 20px;
  border: 1px solid #e8eaec;
  border-radius: 6px;
  padding: 15px;
  background-color: #fafafa;
}

.factory-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8eaec;
}

.factory-header h4 {
  margin: 0;
  color: #2d8cf0;
  font-size: 16px;
  font-weight: 600;
}

.factory-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.device-count {
  color: #999;
  font-size: 12px;
}
</style>
